import { api, adminApi } from './api'

// User
export const getActiveAnnouncements = () => api('announcements', { action: 'active' })
export const markAnnouncementRead = (id) => api('announcements', { action: 'mark_read', id })

// Admin
export const listAnnouncements = () => adminApi('announcements', { action: 'admin_list' })
export const createAnnouncement = (payload) => adminApi('announcements', { action: 'create', ...payload })
export const updateAnnouncement = (id, updates) => adminApi('announcements', { action: 'update', id, ...updates })
export const toggleAnnouncement = (id, active) => adminApi('announcements', { action: 'toggle', id, active })
export const removeAnnouncement = (id) => adminApi('announcements', { action: 'remove', id })
